import React, { useEffect } from "react";
import ModalComponent from "../../../components/modalComponent";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TextInput from "../../../components/textInput";
import ButtonComponent from "../../../components/button";
import SelectInput from "../../../components/selectInput";

function transformCurrencyData(currencyData) {
  return currencyData.map((item) => ({
    value: item.id,
    label: item.siglas.trim()
  }));
}

const CreateBillingUnitModal = ({
  billingUnitData,
  open,
  onClose,
  onSubmitFunction,
  currencyOptions
}) => {
  const schema = yup.object().shape({
    name: yup
      .string()
      .required("El nombre de la unidad de negocio es requerido")
      .test(
        "uniqueName",
        "El nombre ya está en uso",
        (value) =>
          !billingUnitData.some(
            (billingUnit) => billingUnit.label === value.toUpperCase()
          )
      ),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
    }
  });

  useEffect(() => {
    if (!open) {
      reset();
    }
  }, [open, reset]);

  const handleFormSubmit = (formData) => {
    onSubmitFunction(formData);
    reset();
    onClose();
  };

  return (
    <ModalComponent
      open={open}
      onClose={() => {
        reset();
        onClose();
      }}
      onSubmit={handleSubmit(handleFormSubmit)}
      title={"Agregar unidad de facturación"}
    >
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <TextInput
          name="name"
          control={control}
          label="Nombre"
          error={!!errors.name}
          helperText={errors.name?.message}
        />

        <div className="HContainer j-center mt-20">
          <ButtonComponent
            type="submit"
            backgroundColor="#F6C079"
            textColor="#000000"
            width="160px"
          >
            Guardar
          </ButtonComponent>
        </div>
      </form>
    </ModalComponent>
  );
};

export default CreateBillingUnitModal;
